import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Quiz from '../Quiz';
import Challenge from '../Challenge';
import CurrentEntry from '../CurrentEntry';
import InstructorsOnly from '../InstructorsOnly';
import StudentsOnly from '../StudentsOnly';
import GoLive from '../../GoLive';
import {
  setCurrentEntry,
  resetCurrentEntry,
  setCurrentTopic,
  addUserToSlackChannel
} from '../../../actions';
import CompletionCertificateBanner from '../../CompletionCertificate/Banner';
import './style.css';

const Content = () => {
  const params = useParams();
  const dispatch = useDispatch();
  // Redux
  const organization = useSelector((state) => state.organization);
  const currentUser = useSelector((state) => state.currentUser);
  const currentEntry = useSelector((state) => state.currentEntry);
  const currentTopic = useSelector((state) => state.currentTopic);
  const course = useSelector((state) => state.currentClass);
  const courseTopics = useSelector((state) => state.courseTopics);
  // Params
  const entryId = params?.entryId || null;
  const topicId = params?.topicId || null;
  // Course
  const title = course?.title || null;
  const isLive = course?.isLive || false;
  const streamingLink = course?.streamingLink || null;
  // Course Topics
  const hasTopics =
    Array.isArray(courseTopics?.list) && courseTopics.list.length > 0;
  // Entry
  const contentType = currentEntry?.contentType || null;

  useEffect(() => {
    if (entryId !== currentEntry?.id) {
      dispatch(setCurrentEntry(entryId));
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }

    if (topicId !== currentTopic?.id) {
      dispatch(setCurrentTopic(topicId));
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }, [currentEntry?.id, currentTopic?.id, dispatch, entryId, topicId]);

  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    return function cleanup() {
      dispatch(resetCurrentEntry());
    };
  }, [dispatch]);

  useEffect(() => {
    // INTEGRATE SLACK
    const slackUserId = currentUser?.slackUserId || null;
    const integrateSlack = organization?.integrateSlack || null;
    const slackChannel = course?.slackChannel || null;

    if (integrateSlack && slackChannel && slackUserId) {
      dispatch(
        addUserToSlackChannel({
          channelId: slackChannel,
          slackUserId
        })
      );
    }
  }, [
    course?.slackChannel,
    currentUser?.slackUserId,
    dispatch,
    organization?.integrateSlack
  ]);

  if (!course?.id) {
    return null;
  }

  if (!course?.courseReadOnly && !currentUser?.id) {
    return null;
  }

  if (!currentEntry?.id || !course?.id || !currentTopic?.id || !hasTopics) {
    return null;
  }

  if (!course?.courseReadOnly && !currentUser?.id) {
    return null;
  }

  // Material
  return (
    <main
      role="main"
      className="main-content col-md-9 ml-sm-auto p-3"
    >
      {isLive && streamingLink && (
        <GoLive
          streamingLink={streamingLink}
          title={title}
          buttonText="Join Class"
          buttonClassName=""
          className="mb-3"
          slim
        />
      )}

      <InstructorsOnly />

      <StudentsOnly />

      <CompletionCertificateBanner />

      {contentType === 'challenge' && <Challenge />}

      {contentType === 'quiz' && <Quiz />}

      {contentType === 'material' && <CurrentEntry content={currentEntry} />}
    </main>
  );
};

export default Content;
